import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'


const defaultProps = {

}

export default props => <Autocomplete {...{...defaultProps, ...props} } /> 